// extracted by mini-css-extract-plugin
module.exports = {"instructions":"CreateApiKey_instructions__32mgD","block":"CreateApiKey_block__1DDTx"};